import React from "react";
import { cn } from "@/lib/utils";
import {
    ROLE_CLASSES,
    ROLE_LABEL,
    USER_STATUS_CLASSES,
    USER_STATUS_LABEL,
    POST_STATUS_CLASSES,
    POST_STATUS_LABEL,
    POST_TYPE_LABEL,
} from "@/lib/labels";

const base =
    "inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold uppercase tracking-wide";

export const RoleBadge = ({ role, className }) => (
    <span
        className={cn(base, ROLE_CLASSES[role] || "bg-neutral-200 text-neutral-800", className)}
        data-testid={`role-badge-${role}`}
    >
        {ROLE_LABEL[role] || role}
    </span>
);

export const UserStatusBadge = ({ status, className }) => (
    <span
        className={cn(
            base,
            USER_STATUS_CLASSES[status] || "bg-neutral-200 text-neutral-800",
            className,
        )}
        data-testid={`user-status-badge-${status}`}
    >
        {USER_STATUS_LABEL[status] || status}
    </span>
);

export const PostStatusBadge = ({ status, className }) => (
    <span
        className={cn(
            base,
            POST_STATUS_CLASSES[status] || "bg-neutral-200 text-neutral-800",
            className,
        )}
        data-testid={`post-status-badge-${status}`}
    >
        {POST_STATUS_LABEL[status] || status}
    </span>
);

export const PostTypePill = ({ type, className }) => (
    <span
        className={cn(
            base,
            "bg-neutral-900 text-white",
            className,
        )}
        data-testid={`post-type-pill-${type}`}
    >
        {POST_TYPE_LABEL[type] || type}
    </span>
);
